export function getPlain<T = any>(state: State | T): T {
  if (!state) return state
  return state instanceof Object && 'toJS' in state ? state.toJS() : state
}
